import { Reducer } from 'redux';

import { FlowCallActionT } from '../api/types';
import {
  ADD_ACTION_CLICKED,
  FLOW_FETCH_SUCCEEDED,
  FLUSH,
  REMOVE_NODE,
  SET_NODES,
  UPDATE_NODE,
} from '../constants/actionTypes';

export type CallFlowNodeStateT = Record<string, FlowCallActionT>;

export const nodes: Reducer<CallFlowNodeStateT> = (state = {}, action) => {
  switch (action.type) {
    case SET_NODES: {
      return { ...action.nodes };
    }
    case ADD_ACTION_CLICKED:
      return state;
    case UPDATE_NODE: {
      const node = Object.assign({}, action.node);
      return Object.assign({}, state, { [action.node.id]: node });
    }
    case REMOVE_NODE: {
      const newState = Object.assign({}, state);
      delete newState[action.id];
      return Object.assign({}, newState);
    }
    case FLOW_FETCH_SUCCEEDED: {
      const nodes = Object.assign({}, action.flow.nodes);
      return Object.assign({}, nodes);
    }
    case FLUSH:
      return {};
    default:
      return state;
  }
};
